import { SetupForm } from '../constants/setupForm';

/** Most Setup fields become required once a Note Date is entered. */
export const isRequiredOnceNoteDated = (form: SetupForm) => !!form.noteDate;
